import { createMultiStyleConfigHelpers as l, defineStyle as r } from "@chakra-ui/react";
import { ThemeColorVariable as o } from "../../theme-types.js";
import { ThemeColorToken as e, ThemeFontSizeToken as i, ThemeFontToken as b, ThemeBorderToken as A } from "../theme-tokens.js";
import { checkboxAnatomy as v } from "../../../packages/casper-ui-library/node_modules/@chakra-ui/anatomy/dist/esm/components.js";
const { definePartsStyle: c, defineMultiStyleConfig: s } = l(v.keys), h = r({
  m: 0,
  fontFamily: b.Body,
  fontSize: i.Medium,
  color: e.OnSurface,
  width: "100%",
  _disabled: {
    opacity: 1
  }
}), d = "@media(hover: hover)", k = ".chakra-checkbox__control[data-disabled] + .chakra-checkbox__label:hover", t = ".chakra-checkbox__control:not([data-disabled])", n = ".chakra-checkbox__control:not([data-disabled])[data-checked]", a = ".chakra-checkbox__control:not([data-disabled])[data-indeterminate]", C = r({
  [d]: {
    [k]: {
      cursor: "not-allowed"
    },
    _hover: {
      [t]: {
        borderColor: o.AccentHover,
        color: o.AccentHover
      },
      [n]: {
        bg: o.AccentHover,
        color: o.OnAccent
      },
      [a]: {
        borderColor: o.AccentHover,
        bg: o.AccentHover,
        color: o.OnAccent
      }
    }
  },
  _active: {
    [t]: {
      borderColor: o.AccentActive,
      color: o.AccentActive
    },
    [n]: {
      bg: o.AccentActive,
      borderColor: o.AccentActive,
      color: o.OnAccent
    },
    [a]: {
      color: o.OnAccent,
      bg: o.AccentActive,
      borderColor: o.AccentActive
    }
  }
}), S = "[data-checked]:not([data-disabled])&:hover", m = ":not([data-checked]):not([data-disabled]):not([data-invalid]):not([data-indeterminate])&:hover", g = "[data-indeterminate]:not([data-invalid]):not([data-disabled]):hover", _ = "[data-invalid]:not([data-checked]):hover", u = "[data-active]:not([data-disabled])", y = r({
  fontWeight: 900,
  color: e.OnBackground,
  borderColor: e.OnBackground,
  background: "transparent",
  borderRadius: "4px",
  border: A.Small,
  _disabled: {
    opacity: 0.48,
    borderColor: e.OnBackground,
    background: "transparent"
  },
  _checked: {
    background: e.Accent,
    borderColor: e.Accent,
    _disabled: {
      background: e.Accent,
      borderColor: e.Accent,
      color: e.OnAccent
    }
  },
  _invalid: {
    borderColor: e.Error,
    boxShadow: `0 0 0 4px ${o.ErrorContainer}`
  },
  _indeterminate: {
    background: e.Accent,
    borderColor: e.Accent,
    color: e.OnAccent,
    _disabled: {
      borderColor: e.Accent,
      background: e.Accent
    }
  },
  [d]: {
    _hover: {
      cursor: "pointer"
    },
    "[data-disabled]&:hover": {
      cursor: "not-allowed"
    },
    [S]: {
      bg: o.AccentHover,
      borderColor: o.AccentHover,
      color: o.OnAccent,
      _active: {
        bg: o.AccentActive,
        borderColor: o.AccentActive,
        color: o.OnAccent
      }
    },
    [m]: {
      borderColor: o.AccentHover,
      color: o.AccentHover,
      _active: {
        borderColor: o.AccentActive,
        color: o.AccentActive
      }
    },
    [g]: {
      bg: o.AccentHover,
      borderColor: o.AccentHover,
      color: o.OnAccent
    },
    [_]: {
      color: o.ErrorHover,
      borderColor: o.ErrorHover
    }
  },
  [u]: {
    borderColor: o.AccentActive,
    color: o.AccentActive,
    _checked: {
      background: o.AccentActive,
      borderColor: o.AccentActive,
      color: o.OnAccent
    },
    _indeterminate: {
      color: o.OnAccent,
      bg: o.AccentActive
    }
  }
}), p = c({
  control: y,
  label: h,
  container: C
}), H = {
  sm: c({
    control: {
      width: "20px",
      height: "20px"
    }
  }),
  md: c({
    control: {
      width: "24px",
      height: "24px"
    }
  }),
  lg: c({
    control: {
      width: "40px",
      height: "40px",
      borderRadius: "full"
    }
  })
}, O = c({
  control: {
    _invalid: {
      color: e.Error
    },
    _checked: {
      color: e.OnAccent,
      borderColor: e.Accent,
      background: e.Accent,
      _invalid: {
        color: e.OnAccent
      }
    }
  }
}), x = c({
  control: {
    _checked: {
      bg: e.Accent,
      color: e.OnAccent
    }
  }
}), f = {
  normal: x,
  addon: O
}, z = s({
  baseStyle: p,
  sizes: H,
  variants: f
});
export {
  z as checkboxConfig
};
